import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { queryClient } from './lib/queryClient';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

/**
 * A data router with one splat route, so the routes in App keep working as
 * before. A data router is what lets the section editor ask before the
 * browser's back and forward buttons leave it (useBlocker).
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AuthProvider>
        <App />
      </AuthProvider>
    ),
  },
]);

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
